import {isUndefined, startCase, uniq} from "lodash"
import numeral from "numeral"
import React, {useEffect, useRef, useState} from "react"
import {useModal} from "react-modal-hook"
import {useNavigate, useParams} from "react-router-dom"
import {useToasts} from "react-toast-notifications"
import {Adjustments} from "../../components/Adjustments/Adjustments"
import {AdjustmentsColumns} from "../../components/Adjustments/Adjestments.types"
import {
	AccountAuthorizations,
	AccountAuthorizationsColumns,
} from "../../components/AccountAuthorizations/AccountAuthorizations"
import AccountCards, {AccountCardsColumns} from "../../components/AccountCards/AccountCards"
import {Transactions} from "../../components/Transactions/Transactions"
import {TransactionsColumns} from "../../components/Transactions/Transactions.types"
import {EditableDepositProductField} from "../../components/DepositProductField/DepositProductField"
import HorizontalField, {OptionalHorizontalField} from "../../components/HorizontalField/HorizontalField"
import {accountNumberPreview, InformationHiding} from "../../components/InformationHiding/InformationHiding"
import TagsCard from "../../components/Tags/TagsCard"
import {updateAccountTags, getProduct} from "../../resources/account"
import TitleBar, {MetaItemProps, TitleBarAction} from "../../components/TitleBar/TitleBar"
import {AsyncResultComponent} from "../../containers/AsyncResult/AsyncResult"
import {MainSection} from "../../containers/MainSection/MainSection"
import {UnitOrBankUserOnly, UnitUserOnly} from "../../containers/PermissionedUser/PermissionedUser"
import {useAsyncResult} from "../../hooks/useAsyncResult"
import useAsyncResultIdle from "../../hooks/useAsyncResultIdle"
import {useRefreshToken} from "../../hooks/useRefreshToken"
import {
	Account,
	AccountStatusAudit,
	AccountType,
	activateDaca,
	addSecondaryAccountNumber,
	BankReason,
	CloseReason,
	CreditAccount,
	DacaPolicies,
	DacaPolicyPurpose,
	DacaStatusType,
	DepositAccount,
	FinancialBusinessFBOAccount,
	FraudReason,
	getAccountLimits,
	getAccountStatusAudit,
	getAccountWithOwners,
	isBankInAccount,
	isCreditAccount,
	isCreditOperationalAccount,
	isDepositAccount,
	isDepositOrBatchOrFBOAccount,
	isDepositOrBatchOrFBOAccountOrWallet,
	isDepositOrCreditOrFBOAccountOrWallet,
	isDepositOrFBOAccount,
	isDepositOrFBOAccountOrWallet,
	isFrozen,
	isMcaRelatedAccount,
	isMerchantCashAdvanceAccount,
	isOrgFBOAccount,
	isWalletAccount,
	OrgFBO,
	updateDepositAccount,
	updateWalletAccount,
	Wallet,
} from "../../resources/account"
import {Customer, CustomerType, CustomerTypeIcons, getCustomerName, IndividualCustomer} from "../../resources/customer"
import {
	useAccessToken,
	useIsBankUser,
	useIsOrgAdmin,
	useIsUnitAdminOrgAdminBankOperationsOnly,
	useIsUnitUser,
} from "../../services/auth"
import {CloseAccountModal} from "./CloseAccount"
import {CreateAdjustmentModal} from "./CreateAdjustment"
import {AccountStatements} from "../../components/Statements/AccountStatements"
import {FreezeAccountModal} from "./FreezeAccount"
import classNames from "classnames"
import {Editable, EditableString} from "../../components/HorizontalField/EditableHorizontalField"
import {hasPermission} from "../../services/permission"
import {WithdrawFromAccountModal} from "../../components/WithdarwFromAccountModal/WithdrawFromAccountModal"
import {getBankVerificationPdf, getWireInstructionsPdf} from "../../resources/accountStatement"
import {downloadFile} from "../../utilities/file"
import Drawer from "../../components/Drawer/Drawer"
import AccountLimits from "../../components/Limits/AccountLimits/AccountLimits"
import ReactTooltip from "react-tooltip"
import BodyPortal from "../../components/BodyPortal/BodyPortal"
import Payments from "../../components/Payments/Payments"
import {ActionButton, ActionItem, ActionItemProps} from "../../components/ActionButton/ActionButton"
import Icon from "../../components/Icon/Icon"
import {TutorialButton} from "../../components/Tutorial/TutorialButton"
import {TutorialActionProps, TutorialModalProps} from "../../components/Tutorial/TutorialModal"
import {generateCreateCardRequest, generateIncomingAchRequest} from "../../components/Tutorial/TutorialPayloads"
import {AccountOwners} from "../../components/AccountOwners/AccountOwners"
import moment from "moment"
import {CreditAccountSummary} from "./CreditAccountSummary"
import {CreditOperationalAccountSummary} from "./CreditOperationalAccountSummary"
import {getBankDetails} from "../../utilities/getBankDetails"
import {AccountStatusField} from "./AccountStatusField"
import {BankNameAndLogo} from "../../components/BankNameAndLogo/BankNameAndLogo"
import {DacaStatusAction, DacaStatusModal} from "./DacaStatus"
import {DACASettingsModal} from "./DACASettingsModal"
import {OriginateWireModal} from "./OriginateWire"
import {useAuditLog} from "../../components/AuditLogDrawer/useAuditLog"
import {AuditLogEventsHeaderMetaItemProps} from "../../components/AuditLogEventsHeader/AuditLogEventsHeader"
import {IcomoonIconName} from "../../components/Icon/icons"
import AuditLogActionButton from "../../components/AuditLogActionButton/AuditLogActionButton"
import AuditLogDrawer from "../../components/AuditLogDrawer/AuditLogDrawer"
import {OrgName} from "../../components/OrgName/OrgName"
import {BankName} from "../../components/BankName/BankName"
import CheckPayments, {CheckPaymentsColumns} from "../../components/CheckPayments/CheckPayments"
import {CheckDeposits} from "../../components/CheckDeposits/CheckDeposits"
import {CheckDepositColumns} from "../../components/CheckDeposits/CheckDeposit.types"
import {Accounts} from "../../components/Accounts/Accounts"
import {OneProgramAdmonition} from "../../components/OneProgranAdmonition/OneProgramAdmonition"
import {Org} from "../../resources/org"
import {EditableWalletTermsField} from "../../components/WalletTermsField/WalletTermsField"
import {CreateClosureCheckModal} from "./ClosureCheck/CreateClosureCheck"
import {AccountHolds, AccountHoldsColumns} from "../../components/AccountHolds/AccountHolds"
import {CreateAccountHoldModal} from "./CreateAccountHold"
import InterestViewer from "../../components/Interest/InterestViewer"
import {getDynamicInterestRate} from "../../resources/interestRate"
import ReceivedPayments, {ReceivedPaymentsColumns} from "../../components/ReceivedPayments/ReceivedPayments"
import {AccountsColumns} from "../../components/Accounts/Accounts.types"
import {PaymentColumns} from "../../components/Payments/Payments.types"
import {TabsMeta, TitleBarTabs} from "../../components/TitleBarTabs/TitleBarTabs"
import {useQueryState} from "use-location-state"
import {useListReturnPath} from "../../hooks/useListReturnPath"
import AccountLimitsPage from "./AccountLimitsPage"

export enum AccountPageTabConstants {
	AccountDetails = "AccountDetails",
	AccountLimits = "AccountLimits",
}

type RefreshFunc = () => void

// DACA tooltip helper types and functions
type DacaCounterpartyInfo = {
	name?: string
	routingNumber?: string
	accountNumber?: string
}

const DACA_PURPOSE_LABELS: Record<DacaPolicyPurpose, string> = {
	scheduledAutoClear: "Blocked Account - Daily Sweep",
	manualTransfersByOperator: "Springing DACA - Manual Transfer Only",
}

const DACA_BOTH_PURPOSE_LABEL = "Blocked Account - Daily Sweep + Manual Transfer Rights"

/**
 * Extracts DACA purposes from account attributes.
 * The API returns dacaPolicies.purpose as an array of purposes.
 */
function getDacaPurposes(dacaPolicies?: DacaPolicies): DacaPolicyPurpose[] {
	return dacaPolicies?.purpose ?? []
}

/**
 * Extracts counterparty information from DACA policies.
 * Prefers ACH counterparty, falls back to Wire counterparty.
 */
function getDacaCounterparty(dacaPolicies?: DacaPolicies): DacaCounterpartyInfo | undefined {
	const counterparty = dacaPolicies?.achCounterparty ?? dacaPolicies?.wireCounterparty
	if (!counterparty) {
		return undefined
	}
	return {
		name: counterparty.name,
		routingNumber: counterparty.routingNumber,
		accountNumber: counterparty.accountNumber,
	}
}

/**
 * Returns a human-readable label for DACA purposes.
 */
function getDacaPurposeLabel(purposes: DacaPolicyPurpose[]): string | undefined {
	if (purposes.length === 0) {
		return undefined
	}
	const hasScheduled = purposes.includes("scheduledAutoClear")
	const hasManual = purposes.includes("manualTransfersByOperator")
	if (hasScheduled && hasManual) {
		return DACA_BOTH_PURPOSE_LABEL
	}
	if (hasScheduled) {
		return DACA_PURPOSE_LABELS.scheduledAutoClear
	}
	if (hasManual) {
		return DACA_PURPOSE_LABELS.manualTransfersByOperator
	}
	return purposes.map((purpose) => DACA_PURPOSE_LABELS[purpose] ?? startCase(purpose)).join(", ")
}

function mapAccountTypeToEnum(accountType: string): AccountType {
	switch (accountType) {
		case "depositAccount":
			return AccountType.deposit
		case "batchAccount":
			return AccountType.batch
		case "creditAccount":
			return AccountType.credit
		case "walletAccount":
			return AccountType.wallet
		case "fboAccount":
		case "orgFBOAccount":
			return AccountType.fbo
		case "glAccount":
		case "orgGLAccount":
			return AccountType.gl
		case "creditGLAccount":
			return AccountType.creditGL
		case "orgGeneralLedgerAccount":
			return AccountType.orgGeneralLedger
		case "orgLoanAccount":
			return AccountType.orgLoan
		case "financialBusinessFBOAccount":
			return AccountType.financialBusinessFBO
		default:
			return accountType.replace("Account", "") as AccountType
	}
}

function AccountCardsInternal({
	account,
	accessToken,
	refreshToken,
	enableTutorial,
}: {
	account: Account
	accessToken: string
	refreshToken: number
	enableTutorial: boolean
}): JSX.Element | null {
	const accountCards = (
		<AccountCards
			includedColumns={[
				AccountCardsColumns.id,
				AccountCardsColumns.last4Digits,
				AccountCardsColumns.cardHolder,
				AccountCardsColumns.expiration,
				AccountCardsColumns.status,
				AccountCardsColumns.cardType,
				AccountCardsColumns.createdAt,
				AccountCardsColumns.updatedAt,
				AccountCardsColumns.actions,
			]}
			accountId={account.id}
			accessToken={accessToken}
			externalRefreshToken={refreshToken}
			enableTutorial={enableTutorial}
		/>
	)

	if (isDepositOrCreditOrFBOAccountOrWallet(account) || isOrgFBOAccount(account)) {
		return accountCards
	}
	return null
}

function AccountNumberView({defaultIsHidden, account}: {defaultIsHidden: boolean; account: Account}) {
	if (isDepositOrBatchOrFBOAccountOrWallet(account) && account.attributes.accountNumber) {
		return (
			<HorizontalField label="Account Number">
				<InformationHiding
					element={(accountNumber) => <input type="text" readOnly value={accountNumber} className="input is-static" />}
					getValue={() => account.attributes.accountNumber ?? ""}
					placeholder={accountNumberPreview(account.attributes.accountNumber)}
					defaultIsHidden={defaultIsHidden}
				/>
			</HorizontalField>
		)
	} else if (isDepositOrBatchOrFBOAccount(account) && account.attributes.maskedAccountNumber) {
		return (
			<OptionalHorizontalField
				title="Account Number"
				attribute={account.attributes.maskedAccountNumber.replace(/[*]/g, "●")}
			/>
		)
	}

	return <></>
}

export function BankLogoTitle({title, bankId}: {title: string; bankId: string}) {
	const {name, logo} = getBankDetails(bankId)

	return (
		<div className="flex-container w-100 justify-content-sb gap-10 card-header-title">
			<p className="flex-container font-14 line-h-1-2 align-items-end">{title}</p>
			<div className="flex-container font-14 align-items-center line-h-1-3">
				<BankNameAndLogo name={name} logo={logo} />
			</div>
		</div>
	)
}

function AccountHeader({account}: {account: Account}) {
	if (isCreditOperationalAccount(account) || isCreditAccount(account)) {
		return <BankLogoTitle title="Account Information" bankId={account?.relationships?.bank?.data?.id} />
	}

	return <p className="card-header-title">Account Information</p>
}

function AccountSummary({account}: {account: Account}) {
	if (isCreditOperationalAccount(account)) {
		return <CreditOperationalAccountSummary account={account} />
	}

	if (isCreditAccount(account)) {
		return <CreditAccountSummary account={account} />
	}

	return null
}

function AccountInternal({
	value,
	accessToken,
	refresh,
	isOrgAccount,
	accountStatusAudit,
	currentTab,
	setCurrentTab,
}: {
	value: {account: Account; included: Array<Customer>}
	accessToken: string
	refresh: RefreshFunc
	isOrgAccount: boolean
	accountStatusAudit: AccountStatusAudit | undefined
	currentTab: AccountPageTabConstants
	setCurrentTab: (tab: AccountPageTabConstants) => void
}) {
	const navigate = useNavigate()
	const listReturnPath = useListReturnPath("/accounts/")
	const account = value.account
	const updatedAt = account.attributes.updatedAt
	const {attributes} = account
	const isIndividualAccount = value.included?.filter((i) => i.type == "individualCustomer").length > 0
	const org = value.included && (value.included.find((i) => (i.type as string) === "org") as unknown as Org)
	const accountName = attributes.name
	const isReserve = isCreditOperationalAccount(account)
	const individuals: Array<IndividualCustomer> = value.included
		?.filter((c) => c.type == "individualCustomer")
		.map((c) => c as IndividualCustomer)

	const getCustomerDataArray = (
		account: DepositAccount | CreditAccount | FinancialBusinessFBOAccount | Wallet | OrgFBO
	) => {
		switch (account.type) {
			case "depositAccount":
				return [account.relationships.customer?.data ?? [], account.relationships?.customers?.data ?? []]
			case "creditAccount":
				return [account.relationships.customer?.data ?? []]
			case "financialBusinessFBOAccount":
				return [account.relationships.customer.data]
			case "walletAccount":
				return [account.relationships.customer?.data ?? []]
			case "fboAccount":
				return [account.relationships.customer?.data ?? []]
		}
	}

	const accountCustomer =
		isDepositOrFBOAccount(account) || isCreditAccount(account) || isWalletAccount(account) || isOrgFBOAccount(account)
			? getCustomerDataArray(account).flat()
			: []
	const customer = value.included && value.included.find((c) => c.id == accountCustomer?.[0]?.id)

	const customerIds =
		!isOrgAccount &&
		(isDepositOrFBOAccount(account) || isCreditAccount(account) || isWalletAccount(account) || isOrgFBOAccount(account))
			? uniq(
					getCustomerDataArray(account)
						.flat()
						.map((c) => c.id.toString())
			  )
			: []

	const [showCloseAccount, hideCloseAccount] = useModal(() => (
		<CloseAccountModal closeModal={hideCloseAccount} account={account} onSuccess={refresh} />
	))

	const [showReopenAccount, hideReopenAccount] = useModal(() => (
		<CloseAccountModal closeModal={hideReopenAccount} account={account} onSuccess={refresh} />
	))

	const [showFreezeAccount, hideFreezeAccount] = useModal(() => (
		<FreezeAccountModal closeModal={hideFreezeAccount} account={account} onSuccess={refresh} />
	))

	const [showCreateAdjustment, hideCreateAdjustment] = useModal(() => (
		<CreateAdjustmentModal closeModal={hideCreateAdjustment} account={account} onSuccess={refresh} />
	))

	const [showCreateAccountHold, hideCreateAccountHold] = useModal(() => (
		<CreateAccountHoldModal
			closeModal={hideCreateAccountHold}
			account={account as DepositAccount | FinancialBusinessFBOAccount | Wallet}
			onSuccess={refresh}
		/>
	))

	const [showCreateClosureCheck, hideCreateClosureCheck] = useModal(() => {
		if (!customer) return <></>
		const customerAddress =
			customer.type == "individualCustomer" ||
			customer.type == "businessCustomer" ||
			customer.type == "businessFBOCustomer" ||
			customer.type == "businessWalletCustomer"
				? customer.attributes.address
				: undefined
		const jointAccount = isJointAccount()
		const isBusinessAccount = customer.type == "businessCustomer" || customer.type == "businessWalletCustomer"
		const payeeName = getCustomerName(customer)
		return customerAddress && (isDepositAccount(account) || isWalletAccount(account)) ? (
			<CreateClosureCheckModal
				closeModal={hideCreateClosureCheck}
				account={account}
				customerAddress={customerAddress}
				customerId={customer.id}
				payeeName={payeeName}
				accountHolders={jointAccount ? individuals : undefined}
				isBusinessAccount={isBusinessAccount}
				onSuccess={refresh}
			/>
		) : (
			<></>
		)
	})

	const [showWithdrawModal, hideWithdrawModal] = useModal(
		() =>
			isDepositOrFBOAccount(account) ? (
				<WithdrawFromAccountModal
					account={account}
					accessToken={accessToken}
					close={() => {
						hideWithdrawModal()
						refresh()
					}}
				/>
			) : null,
		[]
	)

	// Enter DACA flow moved to DACASettingsModal (Activate/Deactivate/Terminate still use DacaStatusModal).

	const [showTerminateDaca, hideTerminateDaca] = useModal(() => (
		<DacaStatusModal
			action={DacaStatusAction.Terminate}
			closeModal={hideTerminateDaca}
			account={account}
			onSuccess={refresh}
		/>
	))

	const [showActivateDaca, hideActivateDaca] = useModal(() => (
		<DacaStatusModal
			action={DacaStatusAction.Activate}
			closeModal={hideActivateDaca}
			account={account}
			onSuccess={refresh}
		/>
	))

	const [showDeactivateDaca, hideDeactivateDaca] = useModal(() => (
		<DacaStatusModal
			action={DacaStatusAction.Deactivate}
			closeModal={hideDeactivateDaca}
			account={account}
			onSuccess={refresh}
		/>
	))

	const [showOriginateWire, hideOriginateWire] = useModal(() => (
		<OriginateWireModal closeModal={hideOriginateWire} account={account} onSuccess={refresh} />
	))

	const [isEditing, setIsEditing] = useState<string | undefined>(undefined)
	const [isUpdating, setIsUpdating] = useState(false)
	const {addToast} = useToasts()
	const [updateState, updateApp] = useAsyncResultIdle(updateDepositAccount)
	const [updateWalletState, updateWalletApp] = useAsyncResultIdle(updateWalletAccount)
	const [pdfResultState, getPdfRequest] = useAsyncResultIdle(getBankVerificationPdf)
	const [wireInstructionsPdfState, getWireInstructionsPdfRequest] = useAsyncResultIdle(getWireInstructionsPdf)

	const hasInterestTerms = isDepositOrFBOAccount(account) && !!account.attributes.interestTerms
	const fedInterestRateResult = useAsyncResult(() => getDynamicInterestRate(accessToken), [hasInterestTerms])
	const fedBounds = fedInterestRateResult.match<{upper: number; lower: number} | undefined>(
		() => undefined,
		(rate) => ({upper: rate.data.attributes.upperBoundRate, lower: rate.data.attributes.lowerBoundRate}),
		() => undefined
	)

	const [name, setName] = useState(attributes.name)
	const [depositProduct, setDepositProduct] = useState(
		isDepositOrBatchOrFBOAccount(account) ? account.attributes.depositProduct : undefined
	)
	const [walletTerms, setWalletTerms] = useState(isWalletAccount(account) ? account.attributes.walletTerms : undefined)

	const [isDrawerOpen, setIsDrawerOpen] = useState(false)

	const [showEnterDacaSettings, hideEnterDacaSettings] = useModal(() => (
		<DACASettingsModal
			closeModal={hideEnterDacaSettings}
			account={account}
			onSuccess={refresh}
			onActivate={async () => {
				await activateDaca(accessToken, account)
			}}
		/>
	))

	const canUpdateAccount = (account: Account) => {
		switch (account.type) {
			case "batchAccount":
				return hasPermission("account.batch.status", "update")
			default:
				return hasPermission("account.status", "update")
		}
	}

	const toggleDrawer = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
		e.preventDefault()
		setIsDrawerOpen((prevState) => !prevState)
	}

	const [fundPayload, setFundPayload] = useState(generateIncomingAchRequest(account.id))
	const [cardPayload, setCardPayload] = useState(generateCreateCardRequest(account.id))
	const [refreshTransactionToken, refreshTransaction] = useRefreshToken()
	const [refreshCardsToken, refreshCards] = useRefreshToken()
	const ref = useRef(null)
	const tutorialProps: TutorialModalProps = {
		tooltipId: "accountTutorial",
		parentRef: ref,

		actions: [
			{
				actionName: "Fund Account",
				actionIcon: "coin-bank-note--business-products",
				actionIconClassname: "fund-account",
				title: "Simulate an Incoming ACH",
				description: "Simulate an incoming ACH to receive funds into your account",
				successMessage: "Success! You can now see your new funds in the dashboard",
				errorMessage: "There was an error receiving the funds",
				request: {
					method: "POST",
					path: "sandbox/payments",
					payload: fundPayload,
					headers: [
						{headerKey: "Content-Type", headerValue: "application/vnd.api+json"},
						{headerKey: "Cache-Control", headerValue: "no-cache"},
					],
				},
				refreshFunction: refreshTransaction,
				onSendAnotherRequest: () => {
					setFundPayload(generateIncomingAchRequest(account.id))
				},
			},
			...(isIndividualAccount
				? [
						{
							actionName: "Create Card",
							actionIcon: "credit-card-add",
							actionIconClassname: "create-card",
							title: "Test Create Card API",
							description: "Create a debit card for the account",
							successMessage: "Success! You can now see your new card in the dashboard",
							errorMessage: "There was an error creating the new card",
							request: {
								method: "POST",
								path: "cards",
								payload: cardPayload,
								headers: [
									{headerKey: "Content-Type", headerValue: "application/vnd.api+json"},
									{headerKey: "Cache-Control", headerValue: "no-cache"},
								],
							},
							refreshFunction: refreshCards,
							onSendAnotherRequest: () => {
								setCardPayload(generateCreateCardRequest(account.id))
							},
						} as TutorialActionProps,
				  ]
				: []),
		],
	}

	useEffect(() => {
		if (updateState.isOk()) {
			addToast("Account Updated Successfully", {appearance: "success"})
			setIsUpdating(false)
			refresh()
		} else if (updateState.isErr()) {
			const error = updateState.error.errors[0]
			const msg = error.detail ? error.detail : error.title
			addToast(msg, {appearance: "warning"})
			setIsUpdating(false)
		}
	}, [updateState])

	useEffect(() => {
		if (updateWalletState.isOk()) {
			addToast("Account Updated Successfully", {appearance: "success"})
			setIsUpdating(false)
			refresh()
		} else if (updateWalletState.isErr()) {
			const error = updateWalletState.error.errors[0]
			const msg = error.detail ? error.detail : error.title
			addToast(msg, {appearance: "warning"})
			setIsUpdating(false)
		}
	}, [updateWalletState])

	useEffect(() => {
		pdfResultState.match(
			() => null,
			() => null,
			(pdf) => downloadFile(`Bank Verification Letter - ${account.attributes.name}.pdf`, pdf, "application/pdf"),
			(e) => {
				if (e.errors.length > 0) {
					if (e.errors[0].title == "statements settings - representative name is missing") {
						addToast(
							<span>
								<a
									href="/org-settings#tab=Statements"
									onClick={(e) => {
										e.preventDefault()
										navigate("/org-settings#tab=Statements")
									}}
								>
									statements settings
								</a>{" "}
								- representative name is missing
							</span>,
							{appearance: "warning"}
						)
					} else {
						addToast("Something went wrong", {appearance: "warning"})
					}
				} else {
					addToast("Something went wrong", {appearance: "warning"})
				}
			}
		)
	}, [pdfResultState])

	useEffect(() => {
		wireInstructionsPdfState.match(
			() => null,
			() => null,
			(pdf) => downloadFile(`Wire Instructions - ${account.attributes.name}.pdf`, pdf, "application/pdf"),
			() => {
				addToast("Something went wrong", {appearance: "warning"})
			}
		)
	}, [wireInstructionsPdfState])

	const DepositProductsField = () => {
		if (isDepositOrBatchOrFBOAccount(account) && depositProduct !== undefined) {
			return (
				<EditableDepositProductField
					depositProduct={depositProduct}
					setDepositProduct={setDepositProduct}
					accountId={account.id}
					isEditing={isEditing === "DepositProduct"}
					isDisabled={!isUndefined(isEditing)}
					isAllowed={hasPermission("account.depositProduct", "update")}
					onStartEdit={() => setIsEditing("DepositProduct")}
					onCancel={refresh}
					update={() => {
						updateApp(accessToken, account.id, {depositProduct})
						setIsUpdating(true)
					}}
				/>
			)
		} else return null
	}

	const WalletTermsField = () => {
		if (isWalletAccount(account) && walletTerms !== undefined) {
			return (
				<EditableWalletTermsField
					walletTerms={walletTerms}
					setWalletTerms={setWalletTerms}
					accountId={account.id}
					isEditing={isEditing === "WalletTerms"}
					isDisabled={!isUndefined(isEditing)}
					isAllowed={hasPermission("account.walletTerms", "update")}
					onStartEdit={() => setIsEditing("WalletTerms")}
					onCancel={refresh}
					update={() => {
						updateWalletApp(accessToken, account.id, {walletTerms})
						setIsUpdating(true)
					}}
				/>
			)
		} else return null
	}

	function getIsOrgRevenueAccount() {
		return isOrgAccount && isDepositOrFBOAccount(account) && account.attributes.tags?.purpose == "revenue"
	}

	function isJointAccount() {
		return (
			isDepositAccount(account) &&
			account.relationships.customers &&
			account.relationships.customers?.data.length > 0 &&
			value.included?.length > 1
		)
	}

	function getCloseReason(closeReason: string, fraudReason?: FraudReason, bankReason?: BankReason) {
		switch (closeReason) {
			case CloseReason.Fraud:
				return `Fraud - ${startCase(fraudReason)}`
			case CloseReason.ByBank:
				return `By Bank - ${startCase(bankReason)}`
			default:
				return startCase(closeReason)
		}
	}

	function getCustomerType(customerId: string) {
		const customer = value.included.find((c) => c.id == customerId)
		if (customer) {
			switch (customer.type) {
				case "businessCustomer":
					return "business"
				case "individualCustomer":
					return "individual"
				case "businessFBOCustomer":
					return "businessFBO"
				case "individualWalletCustomer":
					return "individualWallet"
			}
		}
	}

	function getCustomerNameFromId(customerId: string) {
		const customer = value.included.find((c) => c.id == customerId)

		if (customer) {
			return getCustomerName(customer)
		}
	}

	const isUnitUser = useIsUnitUser()
	const isBankUser = useIsBankUser()
	const isUnitOrBankUser = isUnitUser || isBankUser
	const isOrgRevenueAccount = getIsOrgRevenueAccount()
	const isOrgAdmin = useIsOrgAdmin()
	const isUnitAdminOrgAdminBankOperationsOnly = useIsUnitAdminOrgAdminBankOperationsOnly()

	// DACA tooltip data - only available for deposit/FBO accounts
	const dacaPolicies = isDepositOrFBOAccount(account) ? account.attributes.dacaPolicies : undefined
	const dacaPurposes = getDacaPurposes(dacaPolicies)
	const dacaPurposeLabel = getDacaPurposeLabel(dacaPurposes)
	const shouldShowCounterparty = dacaPurposes.includes("scheduledAutoClear")
	const dacaCounterparty = getDacaCounterparty(dacaPolicies)
	const counterpartyName = dacaCounterparty?.name ?? "—"
	const counterpartyRoutingNumber = dacaCounterparty?.routingNumber ?? "—"
	const counterpartyAccountNumber = dacaCounterparty?.accountNumber ?? "—"
	const dacaTooltipId = `daca-type-tooltip-${account.id}`

	const customerNames: MetaItemProps[] = customerIds.map((id, index) => ({
		path: `/customers/${getCustomerType(id)}/${id}`,
		text: getCustomerNameFromId(id),
		icon: index == 0 ? "user-geometric-action-money-fund---users" : undefined,
	}))
	const orgFBOAccountMeta: MetaItemProps[] =
		isWalletAccount(account) && account.relationships.orgFBOAccount?.data.id
			? [
					{
						path: `/accounts/${account.relationships.orgFBOAccount?.data.id}`,
						text: `Org FBO`,
						icon: `bank-account--business-products`,
					},
			  ]
			: []
	const orgGLAccountMeta: MetaItemProps[] =
		isWalletAccount(account) && account.relationships.orgGLAccount?.data.id && isUnitOrBankUser
			? [
					{
						path: `/accounts/${account.relationships.orgGLAccount?.data.id}`,
						text: `Org GL`,
						icon: `bank-account--business-products`,
					},
			  ]
			: []

	const titleMeta: MetaItemProps[] = [...customerNames, ...orgFBOAccountMeta, ...orgGLAccountMeta]

	const firstCustomerType = customerIds.length > 0 ? getCustomerType(customerIds[0]) : undefined
	const auditLogEventsHeaderMetaItems: AuditLogEventsHeaderMetaItemProps[] = [
		{
			text: accountName,
			icon: "bank-account--business-products",
			tooltipText: "Name",
		},
		...(firstCustomerType
			? [
					{
						text: startCase(firstCustomerType),
						icon: CustomerTypeIcons[firstCustomerType as CustomerType],
						tooltipText: "Customer Type",
					},
			  ]
			: []),
		{
			text: startCase(account.type),
			icon: "bank",
			tooltipText: "Account Type",
		},
		...(isUnitOrBankUser && isDepositOrBatchOrFBOAccount(account)
			? [
					{
						text: <OrgName orgId={account.relationships?.org.data.id.toString()} element={"span"} />,
						icon: "user-hierachy2" as IcomoonIconName,
						tooltipText: "Org Name",
					},
			  ]
			: []),
	]

	const actionItems: ActionItemProps[] = []

	if (isUnitAdminOrgAdminBankOperationsOnly) {
		if (isDepositOrFBOAccount(account) && !account.attributes.dacaStatus) {
			actionItems.push({
				title: "Enter DACA",
				icon: "bank",
				stopPropagationOnClick: false,
				onClick: showEnterDacaSettings,
			})
		}
		if (isDepositOrFBOAccount(account) && account.attributes.dacaStatus === DacaStatusType.Entered) {
			actionItems.push({
				title: "Terminate DACA",
				icon: "bank",
				onClick: showTerminateDaca,
			})
			actionItems.push({
				title: "Activate DACA",
				icon: "lock-square-lock-1--interface-essential",
				onClick: showActivateDaca,
			})
		}
		if (isDepositOrFBOAccount(account) && account.attributes.dacaStatus === DacaStatusType.Activated) {
			actionItems.push({
				title: "Deactivate DACA",
				icon: "lock-square-unlock-1--interface-essential",
				onClick: showDeactivateDaca,
			})
			actionItems.push({
				title: "Originate Wire",
				icon: "money-fund-move-found--business-products",
				onClick: showOriginateWire,
			})
		}
	}

	if (isOrgRevenueAccount && isOrgAdmin) {
		actionItems.push({
			title: "Withdraw",
			icon: "payment-coin",
			onClick: () => showWithdrawModal(),
		})
	}

	if (isDepositOrFBOAccount(account) && account.relationships.org.data.id === "2") {
		actionItems.push({
			title: "Add Secondary Account#",
			icon: "hierarchy-square",
			onClick: () => addSecondaryAccountNumber(accessToken, account.id, "3").then(() => refresh()),
		})
	}

	if (
		attributes.status === "Closed" &&
		hasPermission("checkPayment.closure", "create") &&
		customer?.type !== "individualWalletCustomer"
	) {
		actionItems.push({
			title: "Issue Closure Check",
			icon: "check-write--business-products",
			onClick: showCreateClosureCheck,
		})
	}

	if (isUnitUser) {
		actionItems.push({
			title: "Create Adjustment",
			icon: "scale--business-products",
			onClick: () => showCreateAdjustment(),
		})
	}

	if (isDepositOrFBOAccountOrWallet(account)) {
		actionItems.push({
			title: "Create Account Hold",
			icon: "scale--business-products",
			onClick: () => showCreateAccountHold(),
		})
	}

	if (canUpdateAccount(account)) {
		if (attributes.status === "Closed") {
			if (isUnitUser || isBankUser) {
				actionItems.push({
					title: "Reopen Account",
					icon: "undo-arrow--interface-essential",
					onClick: () => showReopenAccount(),
					"data-tip": true,
					"data-iscapture": true,
					"data-for": "reopen-account",
				} as ActionItemProps)
			}
		} else {
			actionItems.push({
				"data-tip": true,
				"data-iscapture": true,
				"data-for": isFrozen(account) ? "unfreeze-account" : "freeze-account",
				title: isFrozen(account) ? "Unfreeze Account" : "Freeze Account",
				icon: "temperature-snow-flake--weather",
				onClick: () => showFreezeAccount(),
			} as ActionItemProps)
			actionItems.push({
				"data-tip": true,
				"data-iscapture": true,
				"data-for": "close-account",
				title: "Close Account",
				icon: "interface-delete-interface-essential",
				color: "#FF506F",
				onClick: () => showCloseAccount(),
			} as ActionItemProps)
		}
	}

	if (isDepositOrFBOAccount(account)) {
		actionItems.push({
			title: "Download Bank Verification",
			icon: "move-snap-down--interface-essential",
			withTopBorder: true,
			onClick: () => getPdfRequest(accessToken, account.id),
		})
		actionItems.push({
			title: "Download Wire Instructions",
			icon: "move-snap-down--interface-essential",
			onClick: () => getWireInstructionsPdfRequest(accessToken, account.id),
		})
	}

	const {showAuditLog, openAuditLogDrawer, closeAuditLogDrawer, isAuditLogDrawerOpened} = useAuditLog()

	return (
		<>
			<TitleBar
				title={accountName}
				breadcrumbs={[{text: "Accounts", path: listReturnPath}]}
				meta={[...titleMeta]}
				noBorder
				noAlignItems
				className="account-title-bar"
			>
				<div className="account-header-right">
					<div className="account-header-actions">
						{showAuditLog && <AuditLogActionButton small onClick={openAuditLogDrawer} />}
						<TitleBarAction>
							{actionItems.length > 0 ? (
								<ActionButton enableActions={true}>
									{actionItems.map((item, index) => (
										<ActionItem key={`${item.title}-${index}`} {...item} />
									))}
								</ActionButton>
							) : null}
						</TitleBarAction>
						{isDepositOrBatchOrFBOAccount(account) ? (
							<>
								<TutorialButton tutorialModalProps={tutorialProps} buttonClassname="space-left" />
							</>
						) : null}
					</div>
					<AccountTabs currentTab={currentTab} setCurrentTab={setCurrentTab} account={account} />
				</div>
			</TitleBar>
			{org?.relationships?.parentOrg && <OneProgramAdmonition />}

			<AuditLogDrawer
				open={isAuditLogDrawerOpened}
				onClose={closeAuditLogDrawer}
				auditLogEventsHeaderMetaItems={auditLogEventsHeaderMetaItems}
				resourceType="account"
				resourceId={account.id}
				relatedAccountId={account.id}
			/>

			{currentTab === AccountPageTabConstants.AccountDetails && (
				<MainSection>
					<div className="columns">
						<div className="column is-4">
							<div className="columns">
								<div className="column">
									<div className="card">
										<div className="card-header">
											<AccountHeader account={account} />
										</div>
										<div className="card-content flex-container flex-dir-col gap-15">
											<AccountSummary account={account} />
											{isCreditAccount(account) && <OptionalHorizontalField title="Type" value="Credit Account" />}
											<OptionalHorizontalField title="ID" attribute={account.id} />
											{isUnitUser && isBankInAccount(account) && account.relationships?.bank?.data?.id && (
												<HorizontalField label="Bank">
													<BankName bankId={account.relationships.bank.data.id.toString()} />
												</HorizontalField>
											)}
											{(isDepositOrBatchOrFBOAccount(account) || isMerchantCashAdvanceAccount(account)) &&
												account.relationships.org.data.id && (
													<UnitOrBankUserOnly>
														<HorizontalField label="Org">
															<OrgName orgId={account.relationships.org.data.id.toString()} element={"span"} />
														</HorizontalField>
													</UnitOrBankUserOnly>
												)}
											<Editable
												label="Name"
												isEditing={isEditing === "Name"}
												isDisabled={!isUndefined(isEditing)}
												isAllowed={hasPermission("account.name", "update") && isDepositOrBatchOrFBOAccount(account)}
												isUpdating={isUpdating}
												onStartEdit={() => setIsEditing("Name")}
												onCancel={refresh}
												setValue={setName}
												value={name}
												initial={name}
												update={() => {
													updateApp(accessToken, account.id, {name})
													setIsUpdating(true)
												}}
											>
												{EditableString}
											</Editable>
											<OptionalHorizontalField
												title="Created At"
												attribute={moment(attributes.createdAt).format("L")}
											/>
											<OptionalHorizontalField
												title="Updated At"
												attribute={updatedAt ? moment(updatedAt).format("L") : ""}
											/>
											<AccountStatusField status={attributes.status} accountStatusAudit={accountStatusAudit} />
											{isDepositOrFBOAccount(account) && account.attributes.dacaStatus ? (
												<HorizontalField label="DACA">
													<div className="flex-container justify-content-start align-items-center">
														<span
															className={classNames(
																"is-static",
																account.attributes.dacaStatus === DacaStatusType.Activated && "has-text-danger"
															)}
														>
															{account.attributes.dacaStatus}
															{account.attributes.dacaStatus === DacaStatusType.Activated ? (
																<>
																	{" "}
																	<Icon icon="alert-circle--interface-essential" style={{verticalAlign: "top"}} />
																</>
															) : null}
														</span>
														{dacaPurposeLabel && (
															<span className={"flex-container flex-center margin-l-4"}>
																<Icon
																	icon="information-circle--interface-essential"
																	data-tip="React-tooltip"
																	data-for={dacaTooltipId}
																	size={12}
																/>
																<BodyPortal>
																	<ReactTooltip
																		arrowColor="#2B2C2F"
																		backgroundColor="#2B2C2F"
																		place="bottom"
																		effect="solid"
																		id={dacaTooltipId}
																		className="daca-type-tooltip tooltip-info"
																	>
																		<div className={"flex-container flex-dir-col gap-4"}>
																			<div className={"flex-container flex-dir-col gap-4"}>
																				<div className={"tooltip-info-header"}>
																					<strong>DACA Type:</strong>
																				</div>
																				<div className={"tooltip-info-text"}>{dacaPurposeLabel}</div>
																			</div>
																			{shouldShowCounterparty ? (
																				<div className={"flex-container flex-dir-col gap-4"}>
																					<div className={"tooltip-info-header"}>
																						<strong>Counterparty Information:</strong>
																					</div>
																					<div className={"tooltip-info-text"}>
																						<div>Name: {counterpartyName}</div>
																						<div>Routing Number: {counterpartyRoutingNumber}</div>
																						<div>Account Number: {counterpartyAccountNumber}</div>
																					</div>
																				</div>
																			) : null}
																		</div>
																	</ReactTooltip>
																</BodyPortal>
															</span>
														)}
													</div>
												</HorizontalField>
											) : null}
											<OptionalHorizontalField
												title="Close Reason"
												attribute={
													attributes.closeReason
														? getCloseReason(attributes.closeReason, attributes.fraudReason, attributes.bankReason)
														: undefined
												}
											/>
											<OptionalHorizontalField
												title="Close Notes"
												attribute={attributes.closeReasonText ? attributes.closeReasonText : undefined}
												showTooltip={true}
											/>
											<OptionalHorizontalField
												title="Freeze Reason"
												attribute={attributes.freezeReason ? attributes.freezeReason : undefined}
											/>
											<OptionalHorizontalField
												title="Balance"
												attribute={numeral(attributes.balance / 100).format("$0,0.00")}
												className={attributes.balance >= 0 ? "" : "has-text-danger"}
											/>
											<OptionalHorizontalField
												title="Hold"
												attribute={isReserve ? undefined : numeral(attributes.hold / 100).format("$0,0.00")}
											/>
											<OptionalHorizontalField
												title="Withheld"
												attribute={isReserve ? numeral(attributes.reserve / 100).format("$0,0.00") : undefined}
											/>
											<OptionalHorizontalField
												title="Available"
												attribute={
													isDepositOrFBOAccount(account)
														? numeral(account.attributes.available / 100).format("$0,0.00")
														: undefined
												}
												className={
													isDepositOrFBOAccount(account) && account.attributes.available >= 0 ? "" : "has-text-danger"
												}
											/>
											<OptionalHorizontalField
												title="Overdraft Limit"
												attribute={
													isDepositOrFBOAccount(account) && !isUndefined(account.attributes.overdraftLimit)
														? numeral(account.attributes.overdraftLimit / 100).format("$0,0.00")
														: undefined
												}
											/>
											{isDepositOrBatchOrFBOAccount(account) ? DepositProductsField() : undefined}
											{isCreditAccount(account) && (
												<OptionalHorizontalField
													title="Credit Terms"
													attribute={isCreditAccount(account) ? account.attributes.creditTerms : undefined}
												/>
											)}
											{isWalletAccount(account) ? WalletTermsField() : undefined}

											<OptionalHorizontalField
												title="Routing Number"
												attribute={
													isDepositOrBatchOrFBOAccountOrWallet(account) ? account.attributes.routingNumber : undefined
												}
											/>
											<AccountNumberView account={account} defaultIsHidden={!isBankUser} />
											{isDepositOrFBOAccount(account) &&
											account.attributes.secondaryAccountNumber &&
											account.relationships.org.data.id === "2" ? (
												<OptionalHorizontalField
													title="Secondary Routing Number"
													attribute={
														isDepositOrFBOAccount(account)
															? account.attributes.secondaryAccountNumber?.routingNumber
															: undefined
													}
												/>
											) : null}
											{isDepositOrFBOAccount(account) &&
											account.attributes.secondaryAccountNumber &&
											account.relationships.org.data.id === "2" ? (
												<HorizontalField label="Secondary Account Number">
													<InformationHiding
														element={(accountNumber) => (
															<input type="text" readOnly value={accountNumber} className="input is-static" />
														)}
														getValue={() => account.attributes.secondaryAccountNumber?.accountNumber ?? ""}
														placeholder={accountNumberPreview(account.attributes.secondaryAccountNumber.accountNumber)}
													/>
												</HorizontalField>
											) : null}
											<OptionalHorizontalField
												title="Currency"
												attribute={isDepositOrBatchOrFBOAccount(account) ? account.attributes.currency : undefined}
											/>
											<OptionalHorizontalField
												title="Purpose"
												attribute={isDepositOrFBOAccount(account) ? account.attributes?.tags?.purpose : undefined}
											/>
										</div>
									</div>
								</div>
							</div>

							{isDepositOrFBOAccount(account) && account.attributes.interestTerms ? (
								<div className="columns">
									<div className="column">
										<div className="card">
											<div className="card-header">
												<p className="card-header-title">Interest</p>
											</div>
											<div className="card-content">
												<InterestViewer
													interestTerms={account.attributes.interestTerms}
													fedUpperBound={fedBounds?.upper}
													fedLowerBound={fedBounds?.lower}
												/>
											</div>
										</div>
									</div>
								</div>
							) : null}

							{(isDepositOrFBOAccount(account) || isMerchantCashAdvanceAccount(account)) && (
								<div className="columns">
									<div className="column">
										<TagsCard
											tags={account.attributes.tags}
											onUpdateTags={(token, tags) =>
												updateAccountTags(
													token,
													account.id,
													isWalletAccount(account) ? "walletAccount" : "depositAccount",
													tags
												)
											}
											refresh={refresh}
											editable={hasPermission("account", "update")}
										/>
									</div>
								</div>
							)}
							{isJointAccount() && (
								<div className="columns">
									<div className="column">
										<div className="card">
											<div className="card-header">
												<p className="card-header-title">Account Owners</p>
											</div>
											<div className="card-content">
												<AccountOwners accountOwners={individuals} />
											</div>
										</div>
									</div>
								</div>
							)}
						</div>
						<div className="column">
							{isOrgFBOAccount(account) && (
								<Accounts
									limit={10}
									enableTitle
									enableSearch
									enableOverdraftStatusFilter
									enableExportAccounts
									title="Wallets"
									fullHeight={false}
									enableOrgFilter={true}
									includedColumns={[
										AccountsColumns.id,
										...(isUnitUser ? [AccountsColumns.bank] : []),
										AccountsColumns.name,
										AccountsColumns.purpose,
										AccountsColumns.createdAt,
										AccountsColumns.updatedAt,
										AccountsColumns.balance,
									]}
									type={AccountType.wallet}
									filterByOrgFBOAccount={account.id}
									refresh={refresh}
								/>
							)}
							<AccountCardsInternal
								account={account}
								accessToken={accessToken}
								refreshToken={refreshCardsToken}
								enableTutorial={isIndividualAccount}
							/>
							<Transactions
								fullHeight={false}
								accountId={account.id}
								limit={10}
								enableSearch={true}
								token={accessToken}
								includedColumns={[
									TransactionsColumns.id,
									TransactionsColumns.type,
									TransactionsColumns.customer,
									TransactionsColumns.balance,
									TransactionsColumns.summary,
									TransactionsColumns.amount,
									TransactionsColumns.createdAt,
								]}
								refreshToken={refreshTransactionToken}
							/>
							{!isMcaRelatedAccount(account) && (
								<AccountHolds
									fullHeight={false}
									accountId={account.id}
									limit={10}
									enableSearch={true}
									token={accessToken}
									refresh={refresh}
									includedColumns={[
										AccountHoldsColumns.id,
										AccountHoldsColumns.amount,
										AccountHoldsColumns.status,
										AccountHoldsColumns.createdAt,
										AccountHoldsColumns.expiredAt,
										AccountHoldsColumns.actions,
									]}
								/>
							)}
							{!isMcaRelatedAccount(account) && hasPermission("authorization", "get") && (
								<AccountAuthorizations
									accountId={account.id}
									limit={10}
									token={accessToken}
									refreshPage={refresh}
									enableAmountFilter={true}
									enableLast4DigitsFilter={true}
									includedColumns={[
										AccountAuthorizationsColumns.id,
										AccountAuthorizationsColumns.last4Digits,
										AccountAuthorizationsColumns.merchantName,
										AccountAuthorizationsColumns.status,
										AccountAuthorizationsColumns.reason,
										AccountAuthorizationsColumns.declinedBy,
										AccountAuthorizationsColumns.createdAt,
										AccountAuthorizationsColumns.amount,
										...(useIsUnitUser() ? [AccountAuthorizationsColumns.actions] : []),
									]}
								/>
							)}
							{!isMcaRelatedAccount(account) && (
								<Payments
									enableDirectionFilter={true}
									enableTypeFilter={true}
									enableTitle={true}
									fullHeight={false}
									accountId={account.id}
									limit={10}
									disableDrawer={true}
									token={accessToken}
									includedColumns={[
										PaymentColumns.id,
										PaymentColumns.type,
										PaymentColumns.accountId,
										PaymentColumns.customer,
										PaymentColumns.amount,
										PaymentColumns.status,
										PaymentColumns.createdAt,
										...(hasPermission("payment.achDebit.clear", "create") ? [PaymentColumns.actions] : []),
									]}
								/>
							)}
							{!isMcaRelatedAccount(account) && (
								<ReceivedPayments
									fullHeight={false}
									enableTitle={true}
									enableSearchBox={false}
									enableStatusFilter={true}
									disableDrawer={true}
									accountId={account.id}
									includedColumns={[
										ReceivedPaymentsColumns.id,
										ReceivedPaymentsColumns.type,
										ReceivedPaymentsColumns.direction,
										ReceivedPaymentsColumns.companyName,
										ReceivedPaymentsColumns.amount,
										ReceivedPaymentsColumns.status,
										ReceivedPaymentsColumns.createdAt,
										ReceivedPaymentsColumns.completionDate,
									]}
								/>
							)}
							{!isMcaRelatedAccount(account) && hasPermission("checkPayment", "get") && (
								<CheckPayments
									enableAmountFilter={true}
									enableOrgFilter={false}
									enableDateFilter={true}
									enableTitle={true}
									fullHeight={false}
									enableStatusFilter={true}
									disableDrawer={false}
									enableSearchBox={true}
									enableExport={false}
									enablePurposeFilter={true}
									enableActions={true}
									accountId={account.id}
									includedColumns={[
										CheckPaymentsColumns.id,
										CheckPaymentsColumns.checkNumber,
										CheckPaymentsColumns.isAccountClosureCheck,
										CheckPaymentsColumns.amount,
										CheckPaymentsColumns.status,
										CheckPaymentsColumns.createdAt,
										CheckPaymentsColumns.actions,
									]}
								/>
							)}
							{!isMcaRelatedAccount(account) && hasPermission("checkDeposit", "get") && (
								<CheckDeposits
									enableDateFilter={true}
									enableTitle={true}
									enableOrgFilter={false}
									fullHeight={false}
									enableStatusFilter={true}
									disableDrawer={false}
									enableSearch={true}
									enableExport={true}
									accountId={account.id}
									includedColumns={[
										CheckDepositColumns.id,
										CheckDepositColumns.status,
										CheckDepositColumns.depositDate,
										CheckDepositColumns.expectedCompletionDate,
										CheckDepositColumns.amount,
									]}
								/>
							)}
							{!isMcaRelatedAccount(account) && (
								<UnitUserOnly>
									<Adjustments
										enableTitle={true}
										accountId={account.id}
										fullHeight={false}
										enableUpload={false}
										includedColumns={[
											AdjustmentsColumns.id,
											AdjustmentsColumns.counterAccount,
											AdjustmentsColumns.customer,
											AdjustmentsColumns.direction,
											AdjustmentsColumns.amount,
											AdjustmentsColumns.status,
											AdjustmentsColumns.user,
											AdjustmentsColumns.description,
											AdjustmentsColumns.note,
											AdjustmentsColumns.createdAt,
											AdjustmentsColumns.action,
										]}
									/>
								</UnitUserOnly>
							)}
							{!isMcaRelatedAccount(account) && (
								<AccountStatements
									accountId={account.id}
									accountType={mapAccountTypeToEnum(account.type)}
									limit={5}
									token={accessToken}
								/>
							)}
						</div>
					</div>
				</MainSection>
			)}

			<Drawer
				open={isDrawerOpen}
				onClose={toggleDrawer}
				direction="right"
				className="account-side-drawer"
				title={"Account Limits"}
			>
				{isDrawerOpen ? <AccountLimits accountId={account.id} accessToken={accessToken} /> : null}
			</Drawer>

			<BodyPortal>
				<ReactTooltip
					arrowColor="#FFF"
					place="bottom"
					type="light"
					effect="solid"
					id={"freeze-account"}
					className="account-button-tooltip"
				>
					<p> Freezing the account will freeze all active cards under that account </p>
				</ReactTooltip>

				<ReactTooltip
					arrowColor="#FFF"
					place="bottom"
					type="light"
					effect="solid"
					id={"unfreeze-account"}
					className="account-button-tooltip"
				>
					<p> Unfreezing an account will unfreeze all frozen cards associated with that account </p>
				</ReactTooltip>

				<ReactTooltip
					arrowColor="#FFF"
					place="bottom"
					type="light"
					effect="solid"
					id={"close-account"}
					className="account-button-tooltip"
				>
					<p> Closing the account will close all cards under that account. Closed cards cannot be re-opened </p>
				</ReactTooltip>

				<ReactTooltip
					arrowColor="#FFF"
					place="bottom"
					type="light"
					effect="solid"
					id={"reopen-account"}
					className="account-button-tooltip"
				>
					<p> Reopening an account will not reopen closed cards </p>
				</ReactTooltip>
			</BodyPortal>
		</>
	)
}

function AccountTabs({
	currentTab,
	setCurrentTab,
	account,
}: {
	currentTab: AccountPageTabConstants
	setCurrentTab: (tab: AccountPageTabConstants) => void
	account: Account
}) {
	const tabs: TabsMeta<AccountPageTabConstants>[] = [
		{
			label: "Account Details",
			key: AccountPageTabConstants.AccountDetails,
			prefixIcon: "bank" as IcomoonIconName,
		},
		...(!isMcaRelatedAccount(account)
			? [
					{
						label: "Account Limits",
						key: AccountPageTabConstants.AccountLimits,
						prefixIcon: "dashboard-speed-guage--transportation" as IcomoonIconName,
					},
			  ]
			: []),
	]
	return <TitleBarTabs currentTab={currentTab} setCurrentTab={setCurrentTab} tabs={tabs} navClassName="account-tabs" />
}

export function AccountComponent({
	accountId,
	accessToken,
	isOrgAccount = false,
}: {
	accountId: string
	accessToken: string
	isOrgAccount?: boolean
}) {
	const [refreshToken, refresh] = useRefreshToken()
	const [currentTab, setCurrentTab] = useQueryState<AccountPageTabConstants>(
		"accountTab",
		AccountPageTabConstants.AccountDetails
	)
	const accountAsyncResult = useAsyncResult(
		() => getAccountWithOwners(accessToken, accountId),
		[refreshToken, accountId]
	)
	const accountStatusAuditAsyncResult = useAsyncResult(
		() => getAccountStatusAudit(accessToken, accountId),
		[refreshToken]
	)
	const accountStatusAudit = accountStatusAuditAsyncResult.match<AccountStatusAudit | undefined>(
		() => undefined,
		(a) => a,
		() => undefined
	)

	return (
		<>
			<AsyncResultComponent
				asyncResult={accountAsyncResult}
				accessToken={accessToken}
				isOrgAccount={isOrgAccount}
				accountStatusAudit={accountStatusAudit}
			>
				{({value: value}) => {
					const included = value.included as Array<IndividualCustomer>
					const account = value.account as Account
					return (
						<>
							<AccountInternal
								value={{account, included}}
								accessToken={accessToken}
								refresh={refresh}
								isOrgAccount={isOrgAccount}
								accountStatusAudit={accountStatusAudit}
								currentTab={currentTab}
								setCurrentTab={setCurrentTab}
							/>
							{currentTab === AccountPageTabConstants.AccountLimits && (
								<AccountLimitsPage
									accountId={accountId}
									accessToken={accessToken}
									depositProduct={getProduct(account) ?? undefined}
								/>
							)}
						</>
					)
				}}
			</AsyncResultComponent>
		</>
	)
}

export default function AccountPage() {
	const accessToken = useAccessToken()
	const {accountId = ""} = useParams<{accountId: string}>()

	return <AccountComponent accountId={accountId} accessToken={accessToken} />
}

export function AccountLimitsStatus({accountId, accessToken}: {accountId: string; accessToken: string}) {
	const accountLimits = useAsyncResult(() => getAccountLimits(accessToken, accountId))

	function selectStatusColor(limit: number, usage: number, soft = limit): string {
		if (limit && usage) {
			if (soft != limit && usage > soft && usage / limit < 0.85) "account-limits-reach-soft-limit"
			if (usage / limit > 0.85) return "account-limits-reach-hard-limit"
		}

		return ""
	}

	return (
		<AsyncResultComponent asyncResult={accountLimits} pendingComponent={<></>}>
			{({value: limits}) => {
				const ach = limits.attributes.ach
				const card = limits.attributes.card
				const check = limits.attributes.checkDeposit
				const limitColorsSet = new Set()

				limitColorsSet.add(selectStatusColor(ach.limits.dailyDebit, ach.totalsDaily.debits, ach.limits.dailyDebitSoft))
				limitColorsSet.add(selectStatusColor(ach.limits.dailyCredit, ach.totalsDaily.credits))
				limitColorsSet.add(
					selectStatusColor(ach.limits.monthlyDebit, ach.totalsMonthly.debits, ach.limits.monthlyDebitSoft)
				)
				limitColorsSet.add(selectStatusColor(ach.limits.monthlyCredit, ach.totalsMonthly.credits))

				limitColorsSet.add(selectStatusColor(card.limits.dailyCardTransaction, card.totalsDaily.cardTransactions))
				limitColorsSet.add(selectStatusColor(card.limits.dailyPurchase, card.totalsDaily.purchases))
				limitColorsSet.add(selectStatusColor(card.limits.dailyWithdrawal, card.totalsDaily.withdrawals))
				limitColorsSet.add(selectStatusColor(card.limits.dailyDeposit, card.totalsDaily.deposits))

				limitColorsSet.add(selectStatusColor(check.limits.daily, check.totalsDaily, check.limits.dailySoft))
				limitColorsSet.add(selectStatusColor(check.limits.monthly, check.totalsMonthly, check.limits.monthlySoft))

				return (
					<div className={"account-limits-total-status-container"}>
						<Icon icon={"icon-settings-slider-horizontal"} size={16} />
						<div
							className={classNames(
								"account-limits-total-status",
								limitColorsSet.has("account-limits-reach-soft-limit") && "account-limits-reach-soft-limit",
								limitColorsSet.has("account-limits-reach-hard-limit") && "account-limits-reach-hard-limit"
							)}
						/>
					</div>
				)
			}}
		</AsyncResultComponent>
	)
}
